import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../components/ui/Button';

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div style={{ textAlign: 'center', padding: '80px 20px' }}>
      <div style={{ fontSize: 56, marginBottom: 16 }}>⬡</div>
      <h1 style={{ fontSize: '1.6rem', fontWeight: 800, marginBottom: 8 }}>404 — Page Not Found</h1>
      <p style={{ color: 'var(--text-muted)', fontSize: '0.88rem', marginBottom: 28 }}>
        This route doesn't exist yet.
      </p>
      <Button variant="secondary" onClick={() => navigate('/dashboard')}>← Back to Dashboard</Button>
    </div>
  );
};

export default NotFoundPage;
